import React, { useState } from 'react';

import {
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';

import { BuildRequest } from '../../../../../whitelabel.service';

interface BuildSectionProps {
  platform: 'iOS' | 'Android';
  onStartBuild: (buildRequest: BuildRequest) => Promise<void>;
  isLoading: boolean;
}

const BuildSection: React.FC<BuildSectionProps> = ({ platform, onStartBuild, isLoading }) => {
  const [jobType, setJobType] = useState<'screenshot' | 'enterprise' | 'production'>('screenshot');
  const [branch, setBranch] = useState('master');

  const handleStartBuild = async () => {
    await onStartBuild({ buildType: jobType, branch });
  };

  return (
    <Card>
      <CardHeader title={<Typography variant="h6">{platform} Builds</Typography>} />
      <CardContent>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth>
              <InputLabel>Job Type</InputLabel>
              <Select
                value={jobType}
                onChange={(e) => setJobType(e.target.value as any)}
                label="Job Type"
              >
                <MenuItem value="screenshot">Screenshot</MenuItem>
                <MenuItem value="enterprise">Enterprise</MenuItem>
                <MenuItem value="production">Production</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Branch"
              value={branch}
              onChange={(e) => setBranch(e.target.value)}
              placeholder="master"
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleStartBuild}
              disabled={isLoading || !branch.trim()}
              startIcon={isLoading ? <CircularProgress size={20} /> : null}
            >
              Start {platform} Build
            </Button>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default BuildSection;
